export const UNDO = 'undo';
export const REDO = 'redo';
export const SET = 'set';
export const RESET = 'reset';
